function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import hasInterface from '../../../../../hasInterface';
import Coordinate from '../Coordinate';
import IllegalArgumentException from '../../../../../java/lang/IllegalArgumentException';
import Double from '../../../../../java/lang/Double';
import CoordinateSequence from '../CoordinateSequence';
import Serializable from '../../../../../java/io/Serializable';
import StringBuilder from '../../../../../java/lang/StringBuilder';
var CoordinateArraySequence = /*#__PURE__*/function () {
  function CoordinateArraySequence() {
    _classCallCheck(this, CoordinateArraySequence);
    CoordinateArraySequence.constructor_.apply(this, arguments);
  }
  return _createClass(CoordinateArraySequence, [{
    key: "setOrdinate",
    value: function setOrdinate(index, ordinateIndex, value) {
      switch (ordinateIndex) {
        case CoordinateSequence.X:
          this._coordinates[index].x = value;
          break;
        case CoordinateSequence.Y:
          this._coordinates[index].y = value;
          break;
        case CoordinateSequence.Z:
          this._coordinates[index].z = value;
          break;
        default:
          throw new IllegalArgumentException('invalid ordinateIndex');
      }
    }
  }, {
    key: "size",
    value: function size() {
      return this._coordinates.length;
    }
  }, {
    key: "getOrdinate",
    value: function getOrdinate(index, ordinateIndex) {
      switch (ordinateIndex) {
        case CoordinateSequence.X:
          return this._coordinates[index].x;
        case CoordinateSequence.Y:
          return this._coordinates[index].y;
        case CoordinateSequence.Z:
          return this._coordinates[index].z;
      }
      return Double.NaN;
    }
  }, {
    key: "getCoordinate",
    value: function getCoordinate() {
      if (arguments.length === 1) {
        var i = arguments[0];
        return this._coordinates[i];
      } else if (arguments.length === 2) {
        var index = arguments[0];
        var coord = arguments[1];
        coord.x = this._coordinates[index].x;
        coord.y = this._coordinates[index].y;
        coord.z = this._coordinates[index].z;
      }
    }
  }, {
    key: "getCoordinateCopy",
    value: function getCoordinateCopy(i) {
      return new Coordinate(this._coordinates[i]);
    }
  }, {
    key: "getDimension",
    value: function getDimension() {
      return this._dimension;
    }
  }, {
    key: "getX",
    value: function getX(index) {
      return this._coordinates[index].x;
    }
  }, {
    key: "expandEnvelope",
    value: function expandEnvelope(env) {
      for (var i = 0; i < this._coordinates.length; i++) {
        env.expandToInclude(this._coordinates[i]);
      }
      return env;
    }
  }, {
    key: "copy",
    value: function copy() {
      var cloneCoordinates = new Array(this.size()).fill(null);
      for (var i = 0; i < this._coordinates.length; i++) {
        cloneCoordinates[i] = this._coordinates[i].copy();
      }
      return new CoordinateArraySequence(cloneCoordinates, this._dimension);
    }
  }, {
    key: "toString",
    value: function toString() {
      if (this._coordinates.length > 0) {
        var strBuilder = new StringBuilder(17 * this._coordinates.length);
        strBuilder.append('(');
        strBuilder.append(this._coordinates[0]);
        for (var i = 1; i < this._coordinates.length; i++) {
          strBuilder.append(', ');
          strBuilder.append(this._coordinates[i]);
        }
        strBuilder.append(')');
        return strBuilder.toString();
      } else {
        return '()';
      }
    }
  }, {
    key: "getY",
    value: function getY(index) {
      return this._coordinates[index].y;
    }
  }, {
    key: "toCoordinateArray",
    value: function toCoordinateArray() {
      return this._coordinates;
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return CoordinateArraySequence;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [CoordinateSequence, Serializable];
    }
  }]);
}();
export { CoordinateArraySequence as default };
CoordinateArraySequence.constructor_ = function () {
  this._dimension = 3;
  this._coordinates = null;
  if (arguments.length === 1) {
    if (arguments[0] instanceof Array) {
      var coordinates = arguments[0];
      CoordinateArraySequence.constructor_.call(this, coordinates, 3);
    } else if (Number.isInteger(arguments[0])) {
      var size = arguments[0];
      this._coordinates = new Array(size).fill(null);
      for (var i = 0; i < size; i++) {
        this._coordinates[i] = new Coordinate();
      }
    } else if (hasInterface(arguments[0], CoordinateSequence)) {
      var coordSeq = arguments[0];
      if (coordSeq === null) {
        this._coordinates = new Array(0).fill(null);
        return null;
      }
      this._dimension = coordSeq.getDimension();
      this._coordinates = new Array(coordSeq.size()).fill(null);
      for (var _i = 0; _i < this._coordinates.length; _i++) {
        this._coordinates[_i] = coordSeq.getCoordinateCopy(_i);
      }
    }
  } else if (arguments.length === 2) {
    if (arguments[0] instanceof Array && Number.isInteger(arguments[1])) {
      var _coordinates = arguments[0];
      var dimension = arguments[1];
      this._coordinates = _coordinates;
      this._dimension = dimension;
      if (_coordinates === null) this._coordinates = new Array(0).fill(null);
    } else if (Number.isInteger(arguments[0]) && Number.isInteger(arguments[1])) {
      var _size = arguments[0];
      var _dimension = arguments[1];
      this._coordinates = new Array(_size).fill(null);
      this._dimension = _dimension;
      for (var _i2 = 0; _i2 < _size; _i2++) {
        this._coordinates[_i2] = new Coordinate();
      }
    }
  }
};
CoordinateArraySequence.serialVersionUID = -915438501601840650;